const Footer = () => {
  const leftText = "© Frederik Dennig. All rights reserved.";

  const centerLinks = [
    { href: "https://frederikdennig.com/legal/en/legal-notice", label: "Legal Notice" },
    { href: "https://frederikdennig.com/legal/de/impressum", label: "Impressum" },
  ];

  const rightLinks = [
    { href: "http://frederikdennig.com/legal/en/data-protection", label: "Data Protection" },
    { href: "http://frederikdennig.com/legal/de/datenschutz", label: "Datenschutz" },
  ];

  const renderLinks = (links: { href: string; label: string }[]) =>
    links.map((link, idx) => (
      <span key={link.href} className="flex items-center">
        {idx > 0 && <span className="mx-1">-</span>}
        <a className="hover:underline" href={link.href}>
          {link.label}
        </a>
      </span>
    ));

  return (
    <footer className="absolute bottom-0 w-full bg-slate-100">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between h-full p-4 text-gray-600 text-sm">
        {/* Left */}
        <div className="mb-2 md:mb-0 text-center md:text-left">{leftText}</div>

        {/* Center */}
        <div className="flex justify-center space-x-2">{renderLinks(centerLinks)}</div>

        {/* Right */}
        <div className="flex justify-center md:justify-end mt-2 md:mt-0 space-x-2">{renderLinks(rightLinks)}</div>
      </div>
    </footer>
  );
};

export default Footer;
